import {
    DrawerBody,
    DrawerHeader,
    DrawerHeaderTitle,
    Drawer
} from "@fluentui/react-components/unstable";
import {
    Button
} from "@fluentui/react-components";

import { BookOpenRegular, ChatHelpRegular, Dismiss24Regular, MegaphoneLoudRegular, NotebookQuestionMarkRegular, PeopleCommunityRegular, PersonSupportRegular } from "@fluentui/react-icons";
export interface IAppDrawerProps {
    open: boolean;
    onOpenChange(isOpen: boolean): void;
}

export const LinksDrawer = (props: IAppDrawerProps) => {
    const { open, onOpenChange } = props;

    return (
        <div>
            <Drawer
                type={"overlay"}
                separator
                open={open}
                onOpenChange={(_, { open: isOpen }) => onOpenChange(isOpen)}>
                <DrawerHeader>
                    <DrawerHeaderTitle
                        action={
                            <Button
                                appearance="subtle"
                                aria-label="Close"
                                icon={<Dismiss24Regular />}
                                onClick={() => onOpenChange(false)}
                            />}>
                        MacroView
                    </DrawerHeaderTitle>
                </DrawerHeader>
                <DrawerBody>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', paddingTop: "20px" }} >
                        <Button appearance='transparent' size="large" icon={<PeopleCommunityRegular />} onClick={() => window.open("https://support.macroview.com.au/hc/en-us/community/topics", "_blank", "noopener,noreferrer")} >Community </Button>
                        <Button appearance='transparent' size="large" icon={<ChatHelpRegular />} onClick={() => window.open("https://support.macroview.com.au/hc/en-us", "_blank", "noopener,noreferrer")} >Help Centre</Button>
                        <Button appearance='transparent' size="large" icon={<PersonSupportRegular />} onClick={() => window.open("https://support.macroview.com.au/hc/en-us/requests/new", "_blank", "noopener,noreferrer")}>Request Support </Button>
                        <Button appearance='transparent' size="large" icon={<BookOpenRegular />} onClick={() => window.open("https://support.macroview.com.au/hc/en-us/sections/206712648-Tutorials", "_blank", "noopener,noreferrer")}>Tutorials</Button>
                        <Button appearance='transparent' size="large" icon={<NotebookQuestionMarkRegular />} onClick={() => window.open("https://support.macroview.com.au/hc/en-us/categories/204100587-Announcements-and-FAQ", "_blank", "noopener,noreferrer")}>FAQ </Button>
                        <Button appearance='transparent' size="large" icon={<MegaphoneLoudRegular />} onClick={() => window.open("https://support.macroview.com.au/hc/en-us/categories/204100587-Announcements-and-FAQ", "_blank", "noopener,noreferrer")}>Announcements </Button>
                    </div>
                </DrawerBody>
            </Drawer>
        </div>
    );
};